'use client';

import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { TextPassage } from '@petsmart-ui/sparky';
import { useGoogleRecaptcha } from './useGoogleRecaptcha';
import { isTestRun } from './helpers';

export function GoogleRecaptchaCheckbox({
    className,
    id,
}: {
    className?: string;
    id: string;
}): ReactElement | null {
    const {
        recaptchaErrorCheckbox,
        renderRecaptchaCheckbox,
        useRecaptchaCheckbox,
    } = useGoogleRecaptcha();

    const shouldRenderCheckbox = !isTestRun() && useRecaptchaCheckbox === id;
    const isRecaptchaError = shouldRenderCheckbox && recaptchaErrorCheckbox;

    /**
     * Update recaptch position during window resize (technical debt)
     */
    useEffect(() => {
        const resizeHandler = () => {
            window.dispatchEvent(new WheelEvent('scroll'));
        };
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, []);

    useEffect(() => {
        if (shouldRenderCheckbox) {
            renderRecaptchaCheckbox(id);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps -- prevent render error
    }, [id, useRecaptchaCheckbox]);

    return shouldRenderCheckbox ? (
        <div className={className} data-testid="recaptcha-checkbox">
            {isRecaptchaError && (
                <TextPassage className="sparky-u-color-utility-error">
                    {recaptchaErrorCheckbox}
                </TextPassage>
            )}
            <div id={id} />
        </div>
    ) : null;
}
